import React, { useContext, useEffect, useMemo, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { FiChevronLeft } from 'react-icons/fi';
import { renderFirstName } from '~helpers/common';
import Avatar from '~components/avatar';
// import LastOnline from '~components/last-online';
import Stars from '~components/stars';
import { SkeletonPrimary } from '~components/skeleton';
import ReviewFormModal from '~containers/review/ReviewFormModal';
import { ChatContext } from '../context';
import { getMutualReview } from '~services/reviews';

const ChatHeader = ({ isLoading }) => {
  const intl = useIntl();
  const { recipient, currentUser, discussion } = useContext(ChatContext);
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
  const [existingReview, setExistingReview] = useState(null);
  const [isReviewLoading, setIsReviewLoading] = useState(true);
  const fName = renderFirstName(recipient?.firstName);

  const routePrefix = useMemo(
    () =>
      currentUser.accountType === 'worker'
        ? 'customer'
        : 'worker',
    [currentUser]
  );

  const fetchReview = async () => {
    if (recipient?.personId && currentUser?.personId) {
      setIsReviewLoading(true);
      try {
        const review = await getMutualReview({
          authorId: currentUser.personId,
          receiverId: recipient.personId
        });
        setExistingReview(review);
      } catch (err) {
        console.error('Error fetching review:', err);
      } finally {
        setIsReviewLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchReview();
  }, [recipient?.personId, currentUser?.personId]);

  const handleStarsClick = () => {
    setIsReviewModalOpen(true);
  };

  const handleReviewSubmit = () => {
    fetchReview();
    setIsReviewModalOpen(false);
  };

  return (
    <div className="c-chat-container__header-main discussion-header-truncate">
      <Link to="/chats" className="c-chat-container-header__back" aria-label={intl.formatMessage({ id: 'containers.chat.back', defaultMessage: 'Back to conversations' })}>
        <FiChevronLeft />
      </Link>
      <div className="c-chat-container-header__user discussion-header-truncate">
        <div className="c-chat-container-header__user-payload discussion-header-truncate">
          <Avatar profilePicture={recipient?.profilePicture} firstName={fName} />
          <div className="c-chat-container-header__user-data discussion-header-truncate">
            <h1 className="discussion-header-truncate">
              {isLoading ? (
                <SkeletonPrimary>
                  <Skeleton count={1} width={150} />
                </SkeletonPrimary>
              ) : recipient.firstName ? (
                <Link to={`/${routePrefix}/${recipient.personId}`} className="discussion-header-truncate notranslate">
                  {intl.formatMessage(
                    { id: 'containers.chat.headline', defaultMessage: 'Chat with {firstName}' },
                    {
                      firstName: fName,
                    }
                  )}
                </Link>
              ) : null}
            </h1>
            {/* <p style={{ padding: '10px 12px', textTransform: 'capitalize', color: discussion?.acceptanceState === 'rejected' ? 'red' : discussion?.acceptanceState === 'accepted' ? 'green' : 'orange' }}>
              {discussion?.acceptanceState || recipient.status}
            </p> */}
            <button
              type="button"
              className="c-chat-container-header__rating"
              onClick={handleStarsClick}
              aria-label="Rate this conversation"
              aria-haspopup="dialog"
            >
              <Stars value={existingReview?.score || 0} />
            </button>
          </div>
        </div>
      </div>

      <ReviewFormModal
        isOpened={isReviewModalOpen}
        onToggle={() => setIsReviewModalOpen(false)}
        authorId={currentUser.personId}
        receiverId={recipient.personId}
        receiverFirstName={fName}
        existingReview={existingReview}
        isReviewLoading={isReviewLoading}
        onSubmitSuccess={handleReviewSubmit}
      />
    </div>
  );
};

export default ChatHeader;